//  除法 精度换算
/* eslint-disable */
import i2Multiply from './i2Multiply'
const i2Division = function (n1, n2) {
  const num1 = `${n1}`
  const num2 = `${n2}`
  let t1, t2, r1, r2
  try {
    t1 = num1.toString().split('.')[1].length
  } catch (e) {
    t1 = 0
  }
  try {
    t2 = num2.toString().split('.')[1].length
  } catch (e) {
    t2 = 0
  }
  r1 = Number(num1.toString().replace('.', ''))
  r2 = Number(num2.toString().replace('.', ''))
  return i2Multiply((r1 / r2), Math.pow(10, t2 - t1))
  // return (r1 / r2) * Math.pow(10, t2 - t1)
}

export default i2Division
